module.exports = __webpack_public_path__ + "img/pic5_bg_hover.555230a.png";